import { Builder } from "views/Chat/types";

export const builders: Array<Builder> = [
  {
    uid: "606b2eb665aac72b6032adff",
    fullName: "Nik D.",
    blurb:
      "Nik was the first Product Manager at Udemy and led the redesign of the course-taking experience. built an LMS from scratch for the corporate training market. He was also responsible for the redesign & new features incorporation for Lyft, and managed from the ground up the development of the Learndot platform, which was acquired by ServiceRocket. At Woebot (a $9.5M healthcare startup) he built an AI chatbot to help women with postpartum depression. Nik was working with a couple of A.Team's clients and got amazing feedback. He is based in San Francisco.",
    roles: ["Product Manager"],
    skills: ["Product Strategy", "Product Analytics", "Design Sprint"],
    companies: ["Udemy", "Lyft", "Woebot"],
    yearsOfExperience: 15,
    numberOfMission: 6,
    profilePicture:
      "https://ucarecdn.com/a69bc24c-3ad1-421b-9836-b18898db361a/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "6048f3fa9393cb0013f8f2c3",
    fullName: "Darius D.",
    blurb:
      "Darius, an experienced Lead Designer and Product Designer, is a seasoned UX expert with an impressive portfolio under his belt. Darius has worked with high-profile companies like Google, Disney, and Caterpillar, where he led design teams to overhaul user experiences and create visually stunning and intuitive interfaces. For Google's education platform, Growth Engine, he improved the platform serving 2 million European users by applying Atomic Design principles. At Disney, he redesigned the health and safety portal, SafeD Source, giving it a fresh, modern look. His work with Invideo.io, an online video editor, saw him lead a complete redesign of the web-based video editing platform. Darius's expertise in UX Design, Product Design, and Design Systems, coupled with his ability to lead and deliver high-quality solutions, make him a perfect fit for overhauling your suite of AI and automation tools. He is based in London, UK.",
    roles: ["Product Designer"],
    skills: ["User Research", "Visual design", "UX Design"],
    companies: ["Google", "Disney", "Caterpillar"],
    yearsOfExperience: 20,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/584b1dce-578e-44d5-93be-fad298517106/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "6321eebab351a40013872c22",
    fullName: "Sebastian C.",
    blurb:
      "Sebastien Castiel, a versatile front-end expert, exudes a passion for development and continuous learning that sets him apart. Sebastien has held significant roles at Adaptive, Chief, National Bank of Canada, and Wealthsimple, showcasing his ability to lead and deliver in diverse settings. He has built a niche job board for developers in Montreal from scratch, demonstrating his proficiency in creating innovative and SEO-optimized solutions. His experience with React and Angular, coupled with his eagerness to master Svelte, aligns well with the requirements of the Front-End Developer role at Smlxl. Moreover, his experience in leading teams and mentoring junior or mid-level developers stands testament to his leadership and collaboration skills. Sebastien is the author of five books on front-end development, further highlighting his expertise and commitment to sharing knowledge. He is based in Montreal, Canada.",
    roles: ["Front-End Developer"],
    skills: ["React", "TypeScript", "Next.js"],
    companies: ["Adaptive", "Chief", "National Bank of Canada"],
    yearsOfExperience: 13,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/a3d42968-2af7-4841-9a12-4c46e27a6cd4/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I have been a Lead developer in ContractPodAi for a few years, a company creating a B2B legal tech platform. I've delivered multiple key features used throughout the application ( a multitenant system) such as a Query Builder, Workflow designer integration, integrations with various 3rd party APIs such as Docusign etc.",
      },
    ],
  },
  {
    uid: "5f61223c3f5ff600127e929f",
    fullName: "Ryan C.",
    blurb:
      "Experienced Senior Software Engineer & Founder with a diverse background in software development and information technology.  Ryan has worked and thrived in nearly every size company imaginable from Fortune 100 companies (including Amazon), to a mid-sized company and even a small SaaS startup.  Recently, he has founded his own Software Development firm.",
    roles: ["Back-End Developer"],
    skills: ["Python", "Django", "Apache Airflow"],
    companies: ["Green Mountain Technology", "ProofPort", "Praxeis Technology"],
    yearsOfExperience: 5,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/3b0922ca-a830-4c13-8ff1-55d8f8626072/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I worked at Palo Alto Networks for 2 years as a Senior software engineer in a product called Demisto (Cortex XSoar). I have worked on a complex and strategic product used by Fortune 500 companies and supported multi-tenant solutions.",
      },
    ],
  },
  {
    uid: "63f8d2fb48341a1b22119dd2",
    fullName: "Uday K.",
    blurb:
      "Uday is a highly skilled mobile developer with 20+ years of overall software development experience from brand names JPMorgan and Intel, and over a decade in mobile development, of which the last 7 years building cross-device React Native apps.  Uday has led teams and worked on projects for other renowned companies such as Hive, Virgin, and Vodafone, for which he delivered push notification integrations for both native and RN apps, utilizing AWS SNS and Firebase Cloud Messaging end-to-end. Based in London.",
    roles: ["Mobile Developer", "iOS Developer"],
    skills: ["Swift", "SwiftUI", "Objective-C"],
    companies: ["JPMorgan", "Intel", "Hive"],
    yearsOfExperience: 23,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/b47f0e77-9656-4a0d-87d6-1900b8434afa/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["many steps", "challenging", " strategies"],
        answer:
          "A project I can think of working on is implementing a SharePoint Intranet Portal for a Large Organization: Initial Challenges we had to work through was scope which was extensive and involved multiple departments and stakeholders, also it needed to integrate with various existing systems, and other third-party applications. Our approach and strategies were to do extensive requirements gathering through interviews, surveys, and workshops with department heads and end-users. This helped create a detailed project scope and a clear understanding of user needs. The project was broken down into manageable phases, focusing on delivering core functionality first and gradually expanding features. This allowed for continuous user feedback and the project was successfully implemented.",
      },
    ],
  },
  {
    uid: "605b1a30e0845e00122be7c3",
    fullName: "James B.",
    blurb:
      "James is a senior data engineer with 10+ years of experience in building web applications. He has worked with a variety of technologies and have a passion for learning new things.",
    roles: ["Data Engineer"],
    skills: ["Python", "SQL", "DevOps"],
    companies: ["Link Twenty Two LLC", "EndPoints, Inc.", "Intelcorp Perú"],
    yearsOfExperience: 10,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/a15038fe-1c21-406e-91d4-a4e8ba005832/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "613f21d068e2c90011c13aa4",
    fullName: "Deepanshu S.",
    blurb:
      "6 years of experience as a Senior Machine Learning Engineer with Samsung, Deepanshu is super-passionate about data science, ML & NLP coding. He lead the development of an ML Studio for Samsung, building an intuitive solution that allows users to analyze pipelines including anomaly detections, classifications, clustering & plotting. Very experienced with statistic models, analyzing and setting out regression, predictive analysis with time series & text analytics, for both structured & unstructured datasets. Founded an NPO which partnered with the Indian Government as well as powerhouses including Amazon & Samsung, which is used by over 500K users. He also built an NLP product from scratch for Inspiren, a New-York based startup. Based in NY, USA and is available for 40 hours/week.",
    roles: ["Data Scientist"],
    skills: ["Algorithm Design", "Analytics", "Artificial Intelligence (AI)"],
    companies: ["Samsung", "Inspiren", "Amazon"],
    yearsOfExperience: 8,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/f1ed2560-6b73-4182-aa64-7e945dc5822a/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "606cc65f06c74200123350fb",
    fullName: "Hirsch K.",
    blurb:
      "Has completed over 1,700 hours of work with A.Team's clients and received great feedback - the most recent one was for Onuu, a fintech B2B2C insurance/credit/savings platform and launched the MVP at SXSW within 5 months. As a result of his amazing work, we have taken him on as an honorary member and he has been featured in some of our PR! He previously worked with Deloitte, PwC, Filament AI, and Neowork Ventures, mostly building 0 to 1 products with exciting startups, as a PM and a founder. He has experience with payments at his startup Sci-Insights AI, where he led the Stripe integration from requirements to feature launch. He is based in Canada and is available for 40 hours/week.",
    roles: ["Product Manager"],
    skills: ["Product Strategy", "Design Sprint", "Wireframing"],
    companies: ["Deloitte", "PwC", "Filament AI"],
    yearsOfExperience: 10,
    numberOfMission: 3,
    profilePicture:
      "https://ucarecdn.com/01b5d86f-202b-4027-82d8-3c1205a6fcbe/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "613f282f5be66e0011d082fd",
    fullName: "Krzysztof K.",
    blurb:
      "Krzysztof, a seasoned Product Designer with a solid background in calendar app design. Krzysztof's 16-year career spans various roles including UI/UX Designer, Creative and Conversion Rate Optimization Team Leader, and CEO of Usertive.   At IRL, Krzysztof led the design for a cross-platform social calendar app, showcasing his expertise in calendar functionalities. His work at DaftCode involved hiring and managing a team of 15 professionals, conducting usability tests, and optimizing marketing conversion paths. At PivotFlow, he designed a web application for creating Instagram campaigns, showcasing his understanding of modern UX/UI trends.  Krzysztof's expertise in User Experience, Product Design, and Conversion Rate Optimization, combined with his ability to lead multi-disciplinary teams, makes him an ideal candidate for your project. Krzysztof completed a mission with A.Team and received great feedback. He is based in Warsaw, Poland.",
    roles: ["Product Designer"],
    skills: ["Design Systems", "Prototyping", "Wireframing"],
    companies: ["IRL", "DaftCode", "PivotFlow"],
    yearsOfExperience: 16,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/6d0a2629-ad22-4c55-901e-6051919e4f3a/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "608eba5c3983c400133a7f19",
    fullName: "Ben L.",
    blurb:
      "Ben, an experienced Full-Stack Developer with a strong focus on accelerating feature development. With almost 2 decades of professional experience, Ben has developed a deep expertise in web app development. He has worked with renowned companies such as Walmart, Saks Fifth Avenue, AldoShoes, and Pfizer, building scalable software for millions of online shoppers and efficient systems for enterprise use. At Walmart, he contributed to the next generation of online shopping experience, and at Stylekick he successfully lowered initial page load time from 2.2s to 250ms using React and Flux. Ben is proficient in the required skills of Node.js and React, and brings added expertise in GraphQL, Next.js, and Shopify. Based in Vancouver, Canada.",
    roles: ["Front-End Developer"],
    skills: ["JavaScript", "React", "Firebase"],
    companies: ["Walmart", "Saks Fifth Avenue", "AldoShoes"],
    yearsOfExperience: 10,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/19a1575b-a588-4810-a5dc-bab813b1a315/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I planned, developed and maintained highly available solutions which were used by millions of users. In most of them we managed the user bases, and in some we also processed their payments.",
      },
    ],
  },
  {
    uid: "647364c05979b597d02ade9e",
    fullName: "Naphtali G.",
    blurb:
      "Naphtali is a highly skilled and versatile Back-End Engineer. Rising from QA Engineer, Test Manager, Infra Engineer/DevOps to his current role as a Back-End engineer, Naphtali has consistently shown his ability to wear multiple hats and drive businesses forward. He would be tremendously powerful for a BE automation role. His notable projects include building an eco-system for NFTs at LivePerson, refactoring the Ad Server at IronSource (now Unity) for better engineering efficiency, and forming an Infra team from scratch. Located in Fair Lawn, NJ.",
    roles: ["Back-End Developer"],
    skills: ["Node.js", "API Design", "AWS"],
    companies: ["LivePerson", "IronSource"],
    yearsOfExperience: 8,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/22a3c7f2-9d33-4ca9-8753-9dd3382b8af4/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I have developed 2 backend services at Bloomberg that is B2B. I have worked with McAfee and understands cyber security.",
      },
    ],
  },
  {
    uid: "5fb3e55c872a4600120981bf",
    fullName: "Almog C.",
    blurb:
      "Creating a new and disruptive take on live gaming, where everyone feels like they've seen everything, sounds like an amazing challenge and experience, and definitely one I would like to join. I believe my experience with UX, and as a Product Manager, combined with my passion for iOS apps will make it a great fit.",
    roles: ["Mobile Developer", "iOS Developer"],
    skills: ["Objective-C", "Swift", "React Native"],
    companies: ["Testim", "Sears"],
    yearsOfExperience: 12,
    numberOfMission: 3,
    profilePicture:
      "https://ucarecdn.com/c5a683f6-af85-4bad-a483-14cad2ec45e7/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["methodology", "solutions", "maintained"],
        answer:
          "For Power apps application I follow these steps: 1. Designing Power Apps solution with a clear and well-structured architecture. Document UI design, Power automates, data sources, any external connectors. 2. Consistent naming conventions for variables, controls, screens, and other elements. This makes it easier for other team members to understand your solution. 3. Include comments within your formulas and code to explain the purpose and functionality of different parts of the app.",
      },
    ],
  },
  {
    uid: "jimsonjames",
    fullName: "Jimson J.",
    blurb:
      "Jimson has a strong background in data engineering and designing scalable data processing systems. He built Quest Global software for MRI machines to detect diseases. Thereafter he shifted to Big Data analytics and engineering at Tata Consultancy Services where he extensively used Hadoop and other technologies while designing a data management system for one of the famous retailers. At Intellitix, the leading global provider of solutions for live events such as Coachella, Jimson worked on the blockchain &amp; NFT technologies for the platform used by over 15M users. For CrowdBlink (a new generation of Intellitix), he designed, developed, and managed their data lakehouse, data lake, data pipelines, and ETLs on AWS, using Glue, Kinesis Firehose, Aurora &amp; Lambda functions. Based in Toronto, Canada.",
    roles: ["Data Engineer"],
    skills: ["Analytics", "AWS", "Blockchain (Engineering)"],
    companies: ["Intellitix", "CrowdBlink", "Tata Consultancy Services"],
    yearsOfExperience: 14,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/fbd7e9a3-47e1-4ebf-99a2-1bc44350be5d/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "5f47ce47a1e8ae0012f4d358",
    fullName: "Orian S.",
    blurb:
      "Specializes in the intersection of academic research and industry end-to-end ML development. My passion for machine learning is rooted in a Master's degree in computational cognition, where I researched and mathematically modelled human behavior.",
    roles: ["Data Scientist"],
    skills: ["Python", "Machine Learning", "Deep Learning"],
    companies: ["U Paint It", "Asurion", "TAU Computational Cognition Lab"],
    yearsOfExperience: 6,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/65d025f7-e348-4ac1-ac6b-8d7fada244ff/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "6162a6511a445000123e69c5",
    fullName: "Stephanie T.",
    blurb:
      " I am a driven and empathetic product leader who solves for the end goal of customer delight. In the last 15 years, I have delivered B2B and B2C products across media & entertainment, enterprise software, and market research verticals. I also have a knack for product delivery and can execute from ideation to operations. I am currently serving as a Principal Product Manager at Amazon Studios. On the side, I volunteer my time with DAOs as a marketing and press contributor.",
    roles: ["Product Manager"],
    skills: ["Data Taxonomy", "Product Strategy", "Prototyping"],
    companies: ["Amazon", "NBC Universal", "BuzzBack Market Research"],
    yearsOfExperience: 15,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/4ef7d8db-3a49-4605-a83f-c22a5747f3dd/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "623c927139bd5f0012226115",
    fullName: "Nic B.",
    blurb:
      "Nic, an experienced Senior Product Designer and entrepreneur, who has innovatively shaped the tech industry for over 15 years. Nic has worked with companies like ExpertVoice, Medallia, and Vivint, where he developed a virtual home assistant utilizing machine learning algorithms. Notably, as a co-founder of RNTL, he designed a two-sided marketplace platform for power tool rentals, demonstrating his ability to build products from scratch. With deep expertise in Figma, Prototyping, and UX/UI Design, Nic is proficient at developing the core UI designs, components, and styles for both web and mobile platforms. His active participation in the crypto ecosystem, experience with NFTs, and passion for fast-paced startup environments make him a strong fit for your product designer role. Nic completed numerous missions with A.Team's partners (billed +800 hours so far) and received great feedback. He is based in Los Angeles, USA.",
    roles: ["Product Designer"],
    skills: ["Design Thinking", "Figma", "Gamification"],
    companies: ["ExpertVoice", "RNTL", "Vivint"],
    yearsOfExperience: 15,
    numberOfMission: 4,
    profilePicture:
      "https://ucarecdn.com/73337e51-f03d-4158-b89c-187d34d8a4c9/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "619dcb1261efaa0011c5ae2d",
    fullName: "Slobodan G.",
    blurb:
      "Slobodan, an accomplished Senior Frontend Developer and Software Engineer, is an expert in building scalable web applications with a keen focus on user experience. Slobodan has worked with notable companies such as Microsoft, and numerous startups, where he played significant roles in developing and enhancing software solutions. At Microsoft, he contributed to the successful planning and optimization of the architecture of the DSM Network application using Angular, and at a freelancing project, he improved and optimized various JavaScript projects.&nbsp;Worked for numerous A.Team's clients (2,500 hours), which provided amazing feedback on his work, and he has tens of thousands of engineers following his content on JS best practices. He is part of A.Team's Front-End Experts Guild and is based in Serbia.",
    roles: ["Front-End Developer"],
    skills: ["Angular", "React", "JavaScript"],
    companies: ["Microsoft", "Multilogin"],
    yearsOfExperience: 8,
    numberOfMission: 4,
    profilePicture:
      "https://ucarecdn.com/3f3262ad-7311-43d3-b486-9d4351d0f647/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I worked for InVisionApp (SaaS) which was both B2B and to a lesser extent B2C as most of our revenue came from our Enterprise clients: IBM, Credit Suisse, AmEx, etc. I've also worked briefly with Cyrus Security a startup out of Tel Aviv. While the latter was a startup during my 5 years at InVision I worked both as a Marketing Engineer Full Stack and web analytics for 3 years and then as a Data Engineer for 2 more years.",
      },
      {
        questionKeywords: ["methodology", "solutions", "maintained"],
        answer:
          "When I write code, I put comments and description about what that code is about. I put the Jira story number or some number that business defined the functionality and the date when I started working on so any other developer who looks at it will recognize.",
      },
    ],
  },
  {
    uid: "5fad4d65ca30b60012f6e30d",
    fullName: "Yarden P.",
    blurb:
      "Backend Developer, Achiever with a go-getter attitude. My friends call me the guy who gets things done. Every Task I take upon myself I handle with care and dedication. I Thrive best as part of a team. ",
    roles: ["Back-End Developer"],
    skills: ["Python", "React", "MongoDB"],
    companies: ["Pricemoov", "Rural Senses", "Cyabra"],
    yearsOfExperience: 7,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/51d1e131-bd8c-4c84-bac5-b622c994d3e0/-/preview/160x160/",
    qna: [
      {
        questionKeywords: ["b2b", "enterprise", "cyber", "scale"],
        answer:
          "I worked with Maxwell Health and Williams Hill which provided enterprise solutions and gaming platform, respectively, for large user bases. I also worked with Multichain Ventures who provided white-label software for their clients who had user bases of their own.",
      },
    ],
  },
  {
    uid: "61fd4cc1f90daa00110e9469",
    fullName: "Sultan K.",
    blurb:
      "What I search for in my day-day work is a fulfilling mission and strong team that values curiosity. I specialize in Android apps with native languages.",
    roles: ["Mobile Developer", "iOS Developer", "Android Developer"],
    skills: ["Android", "Team Leadership", "Agora"],
    companies: ["Spotify", "Headspace", "Slacker Radio"],
    yearsOfExperience: 7,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/c9df3600-9d75-41b5-99f3-64f2026c86c2/-/preview/160x160/",
    qna: [
      {
        questionKeywords: [
          "solve a problem",
          "necessary",
          "information",
          "beforehand",
        ],
        answer:
          "One situation where business users were experiencing an issue with a CMS application while editing content, they reported page editing functionality is broken or taking several minutes for a user to load. 1. We don't have enough details from the ticket so we called business users to see the issue they are experiencing and gather all the information, errors needed to debug. 2. Next step is to try to reproduce the Issue on our end, but when we tried to recreate the issue using developer access everything was working as expected and didn't notice any errors in the console. 3. When working with users we noticed their Work Laptops are slow and data download/upload speeds are low compared to speed test on their personal laptop which we didn't experience on our Laptops so we guessed there Business Laptop configuration is different compared to developer laptop and reached out to Networking team to find the difference. 4. Networking team said VPM profiles are the same for all users but while debugging issues found data transferred from VPN to Business users get decrypted which is causing application issues, once exception was added then issue resolved for all business users.",
      },
    ],
  },
  {
    uid: "620a244163f5e20011a893ff",
    fullName: "Fernando F.",
    blurb:
      "Fernando Ferrer, an esteemed Data Engineer, stands atop a 15-year career hallmarked by innovation and technical proficiency. He has partnered with prestigious brands like Pfizer, for whom he established a COVID logistics dashboard, and Harvard University, for which he created high-level clinical data systems. Furthermore, Fernando has showcased his aptitude for Snowflake and Dbt by architecting data-rich solutions from scratch. His prowess includes developing a PySpark data pipeline that handles multiple terabytes of data daily for a global e-commerce company. As a testament to his expertise, he was a co-founder of a big data firm later acquired by a major US-based public company. Located in Toronto, Canada.",
    roles: ["Data Engineer"],
    skills: ["Data Architecture", "Data Modeling", "Data Pipelines"],
    companies: ["Pfizer", "Goodwater Capital", "AddShoppers"],
    yearsOfExperience: 15,
    numberOfMission: 3,
    profilePicture:
      "https://ucarecdn.com/c741832f-ed8e-47c8-a39d-55dd0f21be2f/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "61f591a45286260011eaa6c3",
    fullName: "Aviram B.",
    blurb:
      "Ex: 8200, Weizmann Institute of Science, Columbia & Northwestern Universities. Graduated from the International Space University and have a BSc in computer science. I've always tried to search for solutions to problems. Starting in hackathons and startup competitions in which I won the first places. Later as a first employee in a dataOps startup company, and then as a founder.",
    roles: ["Data Scientist"],
    skills: ["Analytics", "Python", "Data Architecture"],
    companies: [
      "Weizmann Institute of Science",
      "Columbia University",
      "Dataloop AI",
    ],
    yearsOfExperience: 8,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/fb156eee-b291-4201-9269-9e5416a81576/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "61a0a68a86019e001256920a",
    fullName: "Nikita K.",
    blurb:
      "Dedicated, cheerful and highly professional Android engineer with experience in cross-platform development (Flutter, React Native) and server-side driven UIs. Have experience with backend development as well (Scala, Hack, Go) so ready to tackle all the technical challenges to amazing results.",
    roles: ["Mobile Developer", "iOS Developer", "Android Developer"],
    skills: ["Android", "Flutter", "Kotlin"],
    companies: ["Meta", "VOI Technology", "Rebtel"],
    yearsOfExperience: 9,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/78c06295-2110-47ca-8c27-0547e184ec34/-/preview/160x160/",
    qna: [
      {
        questionKeywords: [
          "share an example",
          "many steps",
          "very challenging",
          "strategies",
        ],
        answer:
          "One project that comes to mind was my involvement in the implementation of MS Dynamics CRM for a Government Agency. The agency's goal was to modernize their services for citizens and streamline internal operations using Dynamics CRM. It was a complex endeavor with several intriguing challenges. Below are the details of the project: The project involved the complex task of digitizing and automating government services for citizens while streamlining internal processes using MS Dynamics 365 CRM. The challenges included: Understanding Complex Processes: The initial challenge was comprehending the agency's existing processes, which were often bureaucratic and intricate. These processes needed to be redesigned for automation. Managing Multi-Step Workflows: The project demanded multi-step workflows that spanned several departments and involved multiple stakeholders and employees. Coordination and approvals were crucial. Agile Requirements: The client had evolving requirements, with some aspects following agile methodologies. Flexibility in design and development was paramount. Unclear Requirements: Not all requirements were clear at the beginning, and some evolved during the project, requiring adaptive planning and solutions. Role-Based Security: Ensuring role-based access to data and maintaining data privacy was a challenge, especially given the sensitivity of government information. Approach and Strategies: Comprehensive Process Analysis: I initiated the project by conducting an in-depth analysis of the agency's existing processes (As-Is). This involved extensive interviews with stakeholders, reviewing existing documentation, and creating BPMN diagrams to visualize and document the processes.",
      },
    ],
  },
  {
    uid: "621a616c079ea20011e9101e",
    fullName: "Amir Y.",
    blurb:
      "Amr is a true mobile expert, with vast experience in cross-platform (React Native) &amp; Native (Android/iOS) and with backend development.&nbsp;Amr's work with one of A.Team's enterprise partners (+1600 hours!)  was a huge success. Recently as Tech Lead and Principle engineer at The Economist, he worked on a React Native app with millions of subscribers and re-designed its audio playback stack and file download. That led to the audio load speed being reduced to 300ms and Downloads at a 90% success rate.&nbsp;Worked for American Express and Sainsbury, as well as for startups such as Venn Apps, where he acted as a Lead Android Engineer, architecting and building apps from scratch. Founded his own startup, building from scratch a React Native app as the CTO and Lead Mobile Engineer. He is based in London.",
    roles: ["Mobile Developer", "iOS Developer", "Android Developer"],
    skills: ["Android", "Kotlin", "Firebase"],
    companies: ["American Express", "The Economist", "RewardDays"],
    yearsOfExperience: 7,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/fa504234-1a9c-4fab-b0ce-40bfce3bb3cf/-/preview/160x160/",
    qna: [
      {
        questionKeywords: [
          "methodology",
          "technical solutions",
          "easily maintained",
          "technical team",
        ],
        answer:
          "Here's the methodology I typically follow to ensure that my solutions are easily maintainable by other members of the technical team: Documentation: Thorough and well-organized documentation is the cornerstone of maintainability. I ensure that all aspects of the solution are meticulously documented, including: Data Model: Documentation of data model whether in ERD or in other formats to capture the data model of the solution. Solution Architecture: Detailed architectural diagrams, describing the components and their interactions. Customizations: Documentation for custom entities, fields, forms, views, and relationships. Workflows and Processes: Clearly defined workflows, processes, and business rules. Codebase: Comprehensive comments within custom code, plugins, and scripts. Data Structures: Data models, including schema diagrams and data dictionary. Integration Points: Descriptions of integration interfaces and data flow diagrams. Coding Standards: Enforce coding standards and best practices to ensure consistency in custom code and plugins. This includes naming conventions, indentation, and coding style. Standardized code is easier for team members to understand and work with. Version Control: Utilize version control systems like Git to track changes and maintain a version history of customizations and code. This allows team members to collaborate, identify changes, and roll back if needed. Modular Design: Encourage a modular design approach where customizations are broken down into discrete modules or components. Each module should have a clear purpose and should be documented separately. This allows for easier updates and maintenance. Unit Testing: Implement unit testing for custom code and plugins. Well-documented unit tests not only ensure the correctness of the code but also serve as valuable documentation for future maintainers. Knowledge Transfer and Training: Organize knowledge-sharing sessions and training for team members to familiarize them with the solution's architecture and customizations. This helps onboard new team members quickly and ensures that everyone understands the system's intricacies.",
      },
    ],
  },
  {
    uid: "62864d2ef5e44900118e6780",
    fullName: "Matt O.",
    blurb:
      "A Mobile Developer with 8 years of experience. He has built numerous products on React Native including Learnly, seadvisor.io - an NFT global monitoring tool which was acquired by a private entity for which he also built smart contracts with ETH, and apps for brands such as WorldRemit, a money transfer app that has 5M+ downloads and 4.4 stars rating on Google Play. Matt also functioned as a CTO at Software Bay developing various products in React Native. Based in Poland.",
    roles: ["Mobile Developer", "Android Developer", "iOS Developer"],
    skills: ["GraphQL", "JavaScript", "Nest.js"],
    companies: ["WorldRemit", "Software Bay"],
    yearsOfExperience: 8,
    numberOfMission: 1,
    profilePicture:
      "https://ucarecdn.com/46607807-9e05-4d51-90a5-62a306462d3b/-/preview/160x160/",
    qna: [
      {
        questionKeywords: [
          "many steps",
          "initially seemed",
          "challenging",
          "strategies",
        ],
        answer:
          "In the current project that I am working we had a production release last month. I had work on a functionality where the development itself is 2 months time. It had many steps. First I have analyzed the requirement and breakdown the requirement into multiple stories. The functionality had 5 stage progress bar with 50 questions. First I have created the DataTables related to the functionality in Dataverse. Then I created the core structure header ,footer, progress bar, buttons to save, buttons to Navigate between stages. Then all the questions which will be dynamically displayed depending on the user selection. Finally code to save the data back to dataverse tables.",
      },
      {
        questionKeywords: [
          "solve a problem",
          "necessary",
          "information",
          "beforehand",
        ],
        answer:
          "Few weeks back user reported an issue that they are not seeing the tasks in their UI. I don't have all the information necessary to that. First I made sure it it happening only with that user or with other users too and then started debugging the code where that issue might occur. Tried to recreate same scenario and fixed the issue.",
      },
    ],
  },
  {
    uid: "61780fe3549b5d0012f79323",
    fullName: "Igor G.",
    blurb:
      "A Test Automation Architect who has worked at Intel, Cisco, AMD, and AT&amp;T as an engineer and as a team and technical leader. He’s very experienced in all aspects of QA testing and Automation. For his last project with Gartner, he implemented Cypress and built about 150 test cases for the SoftwareAdvice website. He completed over 2,100 hours with A.Team's clients so far and his works were highly appreciated. He is based in  Canada.",
    roles: ["QA Engineer"],
    skills: ["CI/CD", "Trigger Testing", "Load Testing"],
    companies: ["Intel", "Cisco", "AMD"],
    yearsOfExperience: 15,
    numberOfMission: 3,
    profilePicture:
      "https://ucarecdn.com/decbcaa4-38e7-4ba3-849d-ac43838cd59c/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "6148927c8be71e0012c44903",
    fullName: "Nabeel K.",
    blurb:
      "With ten years of experience as a QA and Automation Engineer, I have gained extensive knowledge in automation layers, including hardware validations, API tests, component tests, end-to-end tests, upgrade tests, and contract testing coverage. I have been a significant contributor to large-scale automation projects that encompassed up to 30,000 tests, and I have developed expertise in popular automation tools, such as Selenium, Cypress, and Appium.",
    roles: ["QA Engineer"],
    skills: ["Java", "Automation Testing", "Typescript"],
    companies: ["Cisco", "Intel", "AMD"],
    yearsOfExperience: 10,
    numberOfMission: 3,
    profilePicture:
      "https://ucarecdn.com/4443b719-b76a-4c8b-b95b-3b3199689cce/-/preview/160x160/",
    qna: [],
  },
  {
    uid: "64498c848a8715a7f96b16d2",
    fullName: "Gabriel M.",
    blurb:
      "I'm an experienced and versatile QA Engineer with a strong background in C#, Python, Java, JavaScript, SQL, GraphQL, and web development technologies. I possess expertise in automation testing, manual testing, API testing, and performance testing across multiple platforms, including web, mobile, and desktop applications. I've honed my skills in various industries, working with companies like Amazon, Dray Alliance, and EVgo. As a diligent and detail-oriented team player, I strive to create and maintain robust testing frameworks, ensure high-quality software releases, and contribute to the continuous improvement of development processes.",
    roles: ["QA Engineer"],
    skills: ["EVgo", "Dray Alliance", "Amazon"],
    companies: ["Android", "Automated Testing", "C#"],
    yearsOfExperience: 12,
    numberOfMission: 2,
    profilePicture:
      "https://ucarecdn.com/3b7646b2-6cb8-409a-81a5-e37e468b2876/-/preview/160x160/",
    qna: [],
  },
];
